module.exports = __webpack_public_path__ + "img/jacksonville-fire-logo.73be9cfd.jpg";